import { useTranslation } from 'next-i18next';
import { BanknotesIcon } from '@heroicons/react/24/solid';

import { CheckCircleIcon } from '@heroicons/react/24/outline';
import { CvDetailInterface } from '../interface/CvDetailInterface';

export const ProfilePreferences = ({ cvDetail }: CvDetailInterface) => {
  const { t } = useTranslation('common');

  // Location and time&pay preferences were removed from the CV edit form, so
  // they are no longer shown. Only the minimum expected salary remains.
  return (
    <>
      { cvDetail?.expectedSalary
      && (
      <section id="looking-for" className="pt-2">
        <h6 className="mb-4 mr-2 border-b border-dotted pb-4 text-lg font-semibold">
          {t('cv.section.label.preferences.type')}
        </h6>

        <div className="mb-2">
          <div>
            <div className="mb-3 flex items-center text-sm font-bold text-ink">
              <BanknotesIcon className="mr-3 size-5 text-ink" />
              {t('cv.detail.expected.salary')}
            </div>
            <div className="mb-3 flex items-start text-sm text-ink-medium">
              <div>
                <CheckCircleIcon className="mr-3 inline-block size-5 text-ink-medium" />
              </div>
              {`${cvDetail?.expectedSalary} `}
              {cvDetail?.salaryCurrency}
            </div>
          </div>
        </div>
      </section>
      )}
    </>
  );
};
